import type { MetaMaskParameters } from 'wagmi/connectors'

import { SITE_LOGO, SITE_NAME, SITE_URL } from '@src/configs/metadata'

export const defaultMetaMaskConfig: MetaMaskParameters = {
    dappMetadata: {
        name: SITE_NAME,
        url: SITE_URL,
        iconUrl: SITE_LOGO,
    },
}
